import { FlowCreatePatientOrderConfigSchema } from 'flow-schema';

import { type api } from 'common';

import { CreatePatientOrderFormFields } from './FormFields';
import { CreatePatientOrderDocumentationMarkdown } from './documentation';
import { type BlockConfigProps } from '../../types';

export const createPatientOrderConfig: BlockConfigProps<
  api.FlowDefinition.CreatePatientOrderBlock['config']
> = {
  nodeHandles: [{ type: 'target' }, { type: 'source' }],
  defaultLabelPrefix: 'createPatientOrder',
  defaultConfig: {
    payload: '',
  },
  configFields: {
    schema: FlowCreatePatientOrderConfigSchema,
    FormFields: CreatePatientOrderFormFields,
  },
  documentationMarkdown: CreatePatientOrderDocumentationMarkdown,
};
